<main id="main-content" tabindex="-1" class="container page-container home__page" role="main" aria-labelledby="pageTitle">
  <app-page-header heading="Olá, {{ userName }}!" subtitle="Bem-vindo ao LeadGen. O que você deseja fazer hoje?" />

  @if (!hasPermissions) {
    <app-empty-state
      variant="boxed"
      heading="Acesso limitado"
      subtitle="Parece que você ainda não tem permissões atribuídas. Entre em contato com o administrador do sistema para liberar seu acesso."
    />
  } @else {
    <div class="grid-cards grid-cols-3 home__grid">
      @if (canViewLeads) {
        <app-action-card heading="Leads" description="Gerencie sua base de contatos e clientes potenciais." icon="groups" tone="info" [link]="['/leads']" />
      }

      @if (canViewOpportunities) {
        <app-action-card heading="Oportunidades" description="Acompanhe negociações e funil de vendas." icon="monetization_on" tone="success" [link]="['/opportunities']" />
      }

      @if (canViewReports) {
        <app-action-card heading="Relatórios" description="Visualize métricas e indicadores de desempenho." icon="bar_chart" tone="report" [link]="['/report']" />
      }

      @if (canViewUsers) {
        <app-action-card heading="Usuários" description="Administre acessos e configurações do sistema." icon="settings" tone="users" [link]="['/users']" />
      }
    </div>
  }
</main>
